import http from 'helpers/APIHelper';
import { httpStatusEnum } from 'appconstants';
import { map } from 'rxjs/operators';
import { getSessionByKey } from 'helpers';
import { suffixPending, suffixFulfilled, suffixRejected } from 'actions';
import { getProtocolDetails } from '../protocoldetail';

export const PRT_INTEGRATIONS_ACTIONS = {
  GET_PROT_INTEGRATIONS: '@protocol/integration/getprotocolintegrations',
  SET_PROT_INTEGRATIONS: '@protocol/integration/setProtocolintegrations',
  GET_PROT_START_INFO: '@protocol/integration/getProtocolstartInfo'
};

export const getProtocolIntegrations = (token, loggerInfo, id) => dispatch => {
  dispatch({
    type: PRT_INTEGRATIONS_ACTIONS.GET_PROT_INTEGRATIONS + suffixPending
  });
  http
    .getWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/integration`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type:
            PRT_INTEGRATIONS_ACTIONS.GET_PROT_INTEGRATIONS + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: PRT_INTEGRATIONS_ACTIONS.GET_PROT_INTEGRATIONS + suffixRejected,
          payload: error
        });
      }
    );
};

export const setProtocolIntegrations = (token, loggerInfo, id, postBody) => (
  dispatch,
  getState
) => (
  http
    .putWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/id/${id}/integration`,
      token,
      loggerInfo,
      JSON.stringify(postBody)
    )
    .pipe(
      map(resp => {
        if (resp.status === httpStatusEnum.SUCCESS) {
          dispatch(
            getProtocolIntegrations(
              token,
              loggerInfo,
              getState().prtDetails.prtInfo.protocolNumber
            )
          );
          dispatch(
            getProtocolDetails(
              token,
              loggerInfo,
              getState().prtDetails.prtInfo.protocolNumber
            )
          );
        }
        return resp;
      })
    )
);

export const getProtocolstartInfo = (token, loggerInfo, id) => dispatch => {
  dispatch({
    type: PRT_INTEGRATIONS_ACTIONS.GET_PROT_START_INFO + suffixPending
  });
  http
    .getWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/start`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type: PRT_INTEGRATIONS_ACTIONS.GET_PROT_START_INFO + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: PRT_INTEGRATIONS_ACTIONS.GET_PROT_START_INFO + suffixRejected,
          payload: error
        });
      }
    );
};
